import React, { useState } from 'react';
import HelpVideoModal from 'components/molecules/help_video_modal';
import { Container, Value } from './style';

interface ModalCapagProps {
  show: boolean;
  title: string;
  indicators: {
    label: string;
    rating: string;
    ratio: string;
  }[];
  onClose: () => void;
}

const ModalCapag: React.FC<ModalCapagProps> = ({ show, title, indicators, onClose }) => {
  const [showMore, setShowMore] = useState(false);
  const [showVideo, setShowVideo] = useState(false);

  const formatRatio = (ratio: string) => {
    if (ratio === '-') return '0';
    if (ratio.startsWith('-.')) return ratio.replace('-.', '0');
    return ratio;
  };

  if (!show) return null;

  return (
    <Container variant={title}>
      <div className="resumo-modal">
        <div className="d-flex justify-content-end">
          <button type="button" id="resumo-close" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="d-flex capag-info">
          <div className="capag-badge d-flex align-items-start">
            <p>Nota CAPAG</p>
            <span className="resumo-title mt-2">{title}</span>
          </div>
          <div className="resumo-content flex-grow-1 justify-content-around">
            {indicators.map(({ label, rating, ratio }, index) => (
              <>
                <div
                  key={label}
                  className="d-flex justify-content-between align-items-center indicador-row"
                >
                  <strong className="label">{label}:</strong>
                  <Value className="rounded" variant={rating}>
                    <span className="mr-1">{rating}</span>
                    <span>{` | ${formatRatio(ratio)}%`}</span>
                  </Value>
                </div>
                {index < indicators.length - 1 && <hr className="m-0" />}
              </>
            ))}
          </div>
        </div>
        <div className="mt-2 alert alert-info d-flex align-items-center justify-content-between ">
          <div className="d-flex align-items-center">
            <div
              className="mr-3 d-flex align-items-center justify-content-center rounded-circle border border-info border-1"
              style={{ width: 40, height: 40 }}
            >
              <span className="material-icons">play_arrow</span>
            </div>

            <div>
              <strong className="d-block lh-sm" style={{ fontSize: 15 }}>
                Como interpretar a nota CAPAG
              </strong>
              <small className="text-muted mb-0">Entenda o que cada indicador representa.</small>
            </div>
          </div>

          <button
            type="button"
            className="btn btn-info"
            style={{ fontSize: 12 }}
            onClick={() => setShowVideo(true)}
          >
            Assistir vídeo explicativo
          </button>
        </div>
        <div className="mt-3 texto-capag">
          <h5 className="mb-2">
            <strong>O que é o CAPAG?</strong>
          </h5>
          <p className="texto mb-1">
            A <strong>Capacidade de Pagamento</strong> (Capag) é um indicador oficial do Tesouro
            Nacional que retrata a <strong>saúde fiscal de Estados e Municípios</strong>. Seu
            cálculo considera três aspectos centrais, nível de endividamento, poupança corrente e
            liquidez, permitindo compreender se o ente público mantém equilíbrio financeiro para
            assumir novos compromissos.
          </p>
          {showMore && (
            <p className="texto">
              Na prática, esse dado serve como um{' '}
              <strong>insumo adicional para o licitante na análise da instituição pública</strong>,
              ajudando a contextualizar o cenário fiscal do órgão. É importante destacar que a Capag
              não indica se o ente é um bom ou mau pagador de contratos de licitação, pois não
              avalia o cumprimento de pagamentos a fornecedores, mas sim a situação fiscal e
              orçamentária do ente.
            </p>
          )}
          <div className="d-flex justify-content-between align-items-center mt-2">
            <button
              type="button"
              className="btn btn-link p-0"
              onClick={() => setShowMore(!showMore)}
            >
              {showMore ? 'Mostrar menos' : 'Mostrar mais'}
            </button>
            {showMore && (
              <a
                href="https://www.tesourotransparente.gov.br/temas/estados-e-municipios/capacidade-de-pagamento-capag"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-link p-0"
              >
                Saiba mais no Tesouro Nacional
              </a>
            )}
          </div>
        </div>
      </div>
      <HelpVideoModal
        modalVideoOpened={showVideo}
        setModalVideoOpened={setShowVideo}
        urlVideo="https://player.vimeo.com/video/1166650077"
        modalTitle="Vídeo explicativo CAPAG"
      />
    </Container>
  );
};
export default ModalCapag;
